{
  "dss": {
    "footer": {
      "legalEntity": "Andreas Stihl Limited"
    }
  }
}
